import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel } from "@components"
import { autoEuropeDrawerData, autoEuropeDrawerErrors, clearAutoEuropeSignals } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeDrawerFooter({ onSubmit, isLoading }) {
	return <>
		<AppDialogCancel onClick={clearAutoEuropeSignals}/>
		<AppBulkEditAction
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			disabled={!Object.values(autoEuropeDrawerErrors.value).every(a => a)}
			onClick={() => onSubmit(autoEuropeDrawerData.value)}
		>
			Save
		</AppBulkEditAction>
	</>
}
